export default "__VITE_ASSET__569d3525__"